import React from 'react';
import StickyBox from 'react-sticky-box/dist/esnext';
import { useMediaQueries } from 'src/utils/MediaQueries';
import { SectionTitle, StyledLink, Sentence } from 'src/components/Typography';
import { mediaQueries } from 'src/style/breakpoints';

const FrequentlyAsked = () => {
  const mqs = useMediaQueries();
  return (
    <div>
      {mqs.tabletLandscapeUp ? (
        <StickyBox offsetTop={100}>
          <SectionTitle
            css={{
              marginBottom: 30,
              paddingTop: 60,
            }}
          >
            Question <br />
            fréquentes
          </SectionTitle>
          <Sentence>Contactez-nous</Sentence>
          <StyledLink>Planifier un appel</StyledLink>
        </StickyBox>
      ) : (
        <div
          css={{
            [mediaQueries.phoneOnly]: {
              paddingLeft: 10,
            },
          }}
        >
          <SectionTitle
            css={{
              paddingTop: 30,
              marginBottom: 15,
            }}
          >
            Question <br />
            fréquentes
          </SectionTitle>
          <Sentence>Contactez-nous</Sentence>
          <StyledLink>Planifier un appel</StyledLink>
        </div>
      )}
    </div>
  );
};

export default FrequentlyAsked;
